(function () {
    'use strict';

    angular
        .module('oddPublicModule')
        .controller('TemplateController', Controller);

    Controller.$inject = ['$scope', '$interval', '$timeout', '$modal', 'CAMPAIGN_TYPE'];

    function Controller($scope, $interval, $timeout, $modal, CAMPAIGN_TYPE) {
        var _autosaveInterval,
            _lastModificationTimeout,
            _modificationMade = false,
            _debounceTime = 3000,
            _requestQueueCount = 0,
            _waitingToSubmit = false;

        /**
         * JS Doc
         * @property {{
         *      Code: string
         *      ConditionalQuestionID: null|string
         *      ConditionalQuestionChoiceID: null|string
         *      Label: string
         *      QuestionAttributeValues: {QuestionAttribute}
         *      QuestionFields: {FieldComponent[]}
         *      QuestionID: string
         *      QuestionLabels: {[QuestionLabel]}
         *      TemplateID: string
         *      Title: string
         *  }} component
         *
         * @type {{
         *      QuestionAttributeValues: {QuestionAttribute[]}
         *      QuestionComponentFieldID: string
         *      QuestionID: string
         *      TemplateID: string
         *      Title: string
         * }} FieldComponent
         *
         * @type {{
         *      AllowComment: string
         *      ForceComment: string
         *      IsMandatory: string
         *      WithAttachmentL string
         *  }} QuestionAttribute
         *
         * @type {{
         *      QuestionLabelID: string
         *      Title: string
         * }} QuestionLabel
         */

        $scope.ctxtCtrl = {
            questionChoiceID: null,
            selection: {},
            comment: null,
            records: [],
            form: null,
            loading: false,
            commentIsOpened: false,
            allFollowUps: [],
            followUps: [],
            internalFollowUps: [],
            followUpModal: null,
            componentFieldAttachmentIndex: 0,

            // Init by the template to tell the question type
            questionType: null,

            // True to enable the Add Record button on Multiple Fields questions
            canAddRecord: true,
            canRemoveRecords: true,
            maxFieldGroupInstances: -1
        };

        $scope.scopeCtxt = $scope;

        if ($scope.campaign.answerByQuestionID[$scope.component.QuestionID]) {
            _.merge($scope.ctxtCtrl, $scope.campaign.answerByQuestionID[$scope.component.QuestionID]);
        }
        if ($scope.campaign.followUpsByQuestionID[$scope.component.QuestionID]) {
            var followUps = $scope.campaign.followUpsByQuestionID[$scope.component.QuestionID];

            if (_.isString(followUps.internalFollowUps) && followUps.internalFollowUps.length > 0) {
                followUps.internalFollowUps = JSON.parse(followUps.internalFollowUps);
                timestampToDate(followUps.internalFollowUps);
            } else {
                followUps.internalFollowUps = [];
            }

            if (_.isString(followUps.followUps) && followUps.followUps.length > 0) {
                followUps.followUps = JSON.parse(followUps.followUps);
                timestampToDate(followUps.followUps);
            } else {
                followUps.followUps = [];
            }

            _.merge($scope.ctxtCtrl, followUps);

            $scope.ctxtCtrl.allFollowUps = combineAllFollowUps();
        }

        // Comment/text answer
        if ($scope.ctxtCtrl.comment) {
            $scope.ctxtCtrl.commentIsOpened = true;
        }

        $timeout(function () {
            $scope.ctxtCtrl.form = $scope['form' + $scope.component.QuestionID];
        }, 0);

        $scope.templateSaveAnswer = function () {
            $scope.campaignContext._hasStartedRequest();
            $scope
                .saveAnswer(getAnswerObject())
                .then(function () {
                    $scope.campaignContext._hasFinishedRequest();
                }, function () {
                    $scope.campaignContext._hasFinishedRequest(true);
                });
        };

        $scope.addInternalNote = function () {
            $scope.ctxtCtrl.followUpModalScope = $scope.$new(true);

            $scope.ctxtCtrl.followUpModalScope.isInternal = true;
            $scope.ctxtCtrl.followUpModalScope.onSave = saveNote;

            $scope.ctxtCtrl.followUpModal = $modal({
                scope: $scope.ctxtCtrl.followUpModalScope,
                templateUrl: require('./followUpModal.tpl.html'),
                show: true,
                backdrop: 'static',
                animation: 'am-fade-and-scale',
                title: 'Add Internal Note',
                placement: 'center'
            });
        };

        $scope.addNoteToPartner = function () {
            $scope.ctxtCtrl.followUpModalScope = $scope.$new(true);

            $scope.ctxtCtrl.followUpModalScope.isInternal = false;
            $scope.ctxtCtrl.followUpModalScope.onSave = saveNote;

            $scope.ctxtCtrl.followUpModal = $modal({
                scope: $scope.ctxtCtrl.followUpModalScope,
                templateUrl: require('./followUpModal.tpl.html'),
                show: true,
                backdrop: 'static',
                animation: 'am-fade-and-scale',
                title: 'Add Note to Partner',
                placement: 'center'
            });
        };

        function saveNote(content) {
            if (_.isUndefined(content) || content.length === 0 || $scope.ctxtCtrl.followUpModalScope.isSaving === true) {
                return;
            }
            $scope.ctxtCtrl.followUpModalScope.isSaving = true;

            var followUpsAttribute = $scope.ctxtCtrl.followUpModalScope.isInternal ? $scope.ctxtCtrl.internalFollowUps : $scope.ctxtCtrl.followUps;
            var newFollowUp = {
                content: content,
                displayName: $scope.campaignContext.currentUser.fullName,
                email: $scope.campaignContext.currentUser.email,
                timestamp: new Date(),
                isInternal: $scope.ctxtCtrl.followUpModalScope.isInternal
            };

            followUpsAttribute.unshift(newFollowUp);

            $scope.updateFollowUps(getFollowUpsToUpdate())
                .then(function () {
                    $scope.ctxtCtrl.followUpModal.$promise.then($scope.ctxtCtrl.followUpModal.hide);

                    newFollowUp._id = generateUUID();
                    $scope.ctxtCtrl.allFollowUps.unshift(newFollowUp);
                })
                .finally(function () {
                    $scope.ctxtCtrl.followUpModalScope.isSaving = false;
                });
        }

        function getFollowUpsToUpdate() {
            var obj = {
                QuestionID: $scope.component.QuestionID
            };
            obj.followUps = _.cloneDeep($scope.ctxtCtrl.followUps);
            obj.internalFollowUps = _.cloneDeep($scope.ctxtCtrl.internalFollowUps);

            _.each(obj.followUps, function (followUp) {
                delete followUp._id;
            });
            _.each(obj.internalFollowUps, function (followUp) {
                delete followUp._id;
            });

            obj.followUps = JSON.stringify(obj.followUps);
            obj.internalFollowUps = JSON.stringify(obj.internalFollowUps);

            return obj;
        }

        function timestampToDate(followUps) {
            _.each(followUps, function (followUp) {
                followUp.timestamp = new Date(followUp.timestamp);
            })
        }

        function combineAllFollowUps() {
            var all = [],
                added;

            _.each($scope.ctxtCtrl.followUps.slice(), function (followUp) {
                followUp._id = generateUUID();
                all.push(followUp);
            });

            _.each($scope.ctxtCtrl.internalFollowUps, function (internal) {
                added = false;
                internal._id = generateUUID();

                _.some(all, function (fromAll, idx) {
                    if (internal.timestamp > fromAll.timestamp) {
                        all.splice(idx, 0, internal);
                        added = true;
                        return true;
                    }
                    return false;
                });

                if (!added) {
                    all.push(internal);
                }
            });
            return all;
        }

        function getAnswerObject() {
            if (!$scope.component.QuestionID) return null;

            var obj = {
                QuestionID: $scope.component.QuestionID
            };

            if ($scope.ctxtCtrl.selection) {
                obj.QuestionChoiceIDs = [];

                _.forOwn($scope.ctxtCtrl.selection, function (value, key) {
                    if (value) {
                        obj.QuestionChoiceIDs.push(key);
                    }
                });
            }
            if ($scope.ctxtCtrl.comment !== null) {
                obj.Comment = $scope.ctxtCtrl.comment;
            }
            if ($scope.component.QuestionFields) {
                obj.Records = [];
                $scope.ctxtCtrl.records.forEach(function (record) {
                    var recArray = [];
                    _.forOwn(record, function (rec, key) {
                        if (!_.startsWith(key, '$') && !_.startsWith(key, '_')) {
                            recArray.push(rec);
                        }
                    });
                    obj.Records.push(recArray);
                });
            }
            if ($scope.component.QuestionLabels) {
                obj.MultiChoiceMultiLabelsIDs = $scope.ctxtCtrl.choiceLabels;
            }

            // Answer Status
            if ($scope.campaign.campaignType && $scope.campaign.campaignType === CAMPAIGN_TYPE.SURVEY) {
                obj.Status = 'Draft';
            } else {
                obj.Status = $scope.ctxtCtrl.status;
            }

            return obj;
        }

        // Accessed by the campaign page controller
        $scope.component._getAnswerObject = getAnswerObject;


        //region Attachments

        $scope.filesAttached = function (compAttachmentId, label, files, errorCb, questionFieldId, recordId) {
            return $scope.uploadAttachments(compAttachmentId, label, files, questionFieldId, recordId)
                .then(function (uploadedFiles) {
                    return uploadedFiles;
                }, function (err) {
                    console.warn('Upload Error:', err.message);
                    if (_.isFunction(errorCb)) {
                        errorCb(err, compAttachmentId, label, files);
                    }
                    return null;
                });
        };

        // Name used for the ng-form name. Overridden by FieldTemplateController for Multiple Fields
        $scope.getAttachmentFormName = function () {
            return 'attForm' + $scope.component.QuestionID;
        };

        // Name used for the ng-form name. Overridden by FieldTemplateController for Multiple Fields
        $scope.getAttachmentInputName = function (compAttachmentId) {
            return 'attInput' + compAttachmentId
        };

        //endregion


        //region Free Text

        /**
         * If no changes have been made within the auto-save delay, cancel the delay.
         */
        $scope.textAnswerModified = function () {
            if (_lastModificationTimeout) {
                $timeout.cancel(_lastModificationTimeout);
            } else {
                $scope.startAutoSaveText();
            }
            _lastModificationTimeout = $timeout(function () {
                $scope.stopAutoSaveText();
                _lastModificationTimeout = null;
            }, _debounceTime + 1);
        };

        $scope.startAutoSaveText = function () {
            _autosaveInterval = $interval(function () {
                saveTextAnswer();
            }, _debounceTime);
        };

        $scope.stopAutoSaveText = function () {
            saveTextAnswer(true);
            $interval.cancel(_autosaveInterval);
        };

        $scope.textAnswerBlurred = function () {
            if (_lastModificationTimeout) {
                $timeout.cancel(_lastModificationTimeout);
                _lastModificationTimeout = null;
                $scope.stopAutoSaveText();
            }
        };

        function saveTextAnswer() {
            $scope.campaignContext._hasStartedRequest();

            $scope
                .saveAnswer(getAnswerObject())
                .then(function () {
                    $scope.campaignContext._hasFinishedRequest();
                }, function () {
                    $scope.campaignContext._hasFinishedRequest(true);
                });
        }

        //endregion


        //region Multiple Choice

        $scope.updateChoiceResponse = function (questionChoiceID, allowMultiple) {
            if (!allowMultiple) {
                $scope.ctxtCtrl.selection = {};

                // Legacy multiple choice template does not provide questionChoiceID
                if (!questionChoiceID) {
                    questionChoiceID = $scope.ctxtCtrl.questionChoiceID;
                }

                $scope.ctxtCtrl.selection[questionChoiceID] = true;
            }

            $scope.ctxtCtrl.isAnswerValid = _.some(_.keys($scope.ctxtCtrl.selection), function (questionId) {
                return $scope.ctxtCtrl.selection[questionId];
            });

            $scope.templateSaveAnswer();
        };

        $scope.isLastChoice = function (choice) {

            var choicesCount = $scope.component.QuestionChoices.length;

            var index = _.indexOf($scope.component.QuestionChoices, choice);

            return (choicesCount - 1) === index;
        };

        function initMultipleChoice() {
            if ($scope.campaign.answerByQuestionID[$scope.component.QuestionID]
                && $scope.campaign.answerByQuestionID[$scope.component.QuestionID].questionChoiceIDs) {

                // Assign saved values
                _.each($scope.campaign.answerByQuestionID[$scope.component.QuestionID].questionChoiceIDs, function (questionChoiceID) {
                    $scope.ctxtCtrl.selection[questionChoiceID] = true;
                    $scope.ctxtCtrl.isAnswerValid = true;
                });
            }
        }
        initMultipleChoice();

        //endregion


        //region Multiple Fields

        $scope.addRecord = function () {
            if (_.isArray($scope.component.QuestionFields)) {
                var recId = generateUUID();
                var newRecord = {
                    _recCtxt: {
                        recordID: recId
                    }
                };
                $scope.component.QuestionFields.forEach(function (componentField) {
                    newRecord[componentField.QuestionComponentFieldID] = {
                        recordID: recId,
                        questionComponentFieldID: componentField.QuestionComponentFieldID
                    };
                });
                $scope.ctxtCtrl.records.push(newRecord);
            }
            updateAddRemoveRecordStates();
        };

        $scope.deleteRecord = function (recordIndex) {
            $scope.ctxtCtrl.records.splice(recordIndex, 1);
            updateAddRemoveRecordStates();
            $scope.templateSaveAnswer();
        };

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        function updateAddRemoveRecordStates() {
            // If min and nb records === min, disable remove button
            var min = Number($scope.getAttributeValue('MinFieldGroupInstances'));

            if (min > 0) {
                $scope.ctxtCtrl.canRemoveRecords = $scope.ctxtCtrl.records.length > min;
            } else {
                $scope.ctxtCtrl.canRemoveRecords = true;
            }

            // If max and nb records === max, disable add button
            var max = Number($scope.getAttributeValue('MaxFieldGroupInstances'));

            if (max > 0) {
                $scope.ctxtCtrl.canAddRecord = $scope.ctxtCtrl.records.length < max;
            } else {
                $scope.ctxtCtrl.canAddRecord = true;
            }
        }

        function initMultipleFields() {
            if ($scope.component.QuestionFields && $scope.component.QuestionFields.length > 0) {
                var savedRecords = $scope.campaign.answerByQuestionID[$scope.component.QuestionID]
                    && $scope.campaign.answerByQuestionID[$scope.component.QuestionID].records;
                if (savedRecords && savedRecords.length > 0) {
                    $scope.ctxtCtrl.records = [];

                    savedRecords.forEach(function (record) {
                        var rec = {
                            _recCtxt: {}
                        };

                        record.forEach(function (field) {
                            rec._recCtxt.recordID = field.recordID;
                            rec[field.questionComponentFieldID] = field;
                        });

                        $scope.ctxtCtrl.records.push(rec);
                    });

                    updateAddRemoveRecordStates();
                } else {
                    var min = Number($scope.getAttributeValue('MinFieldGroupInstances'));

                    if (!(min > 0)) min = 1;

                    for (var i = 0; i < min; i++) {
                        $scope.addRecord();
                    }
                }
            }
        }
        initMultipleFields();

        //endregion


        //region Multiple Choice Multiple Labels

        $scope.updatedMultipleLabelsChoiceResponse = function () {
            $scope.templateSaveAnswer();
        };

        function iniMultipleLabels() {
            if ($scope.component.QuestionLabels && $scope.component.QuestionLabels.length > 0) {
                var savedLabels = $scope.campaign.answerByQuestionID[$scope.component.QuestionID]
                    && $scope.campaign.answerByQuestionID[$scope.component.QuestionID].multiChoiceMultiLabelsIDs;

                if (savedLabels) {
                    $scope.ctxtCtrl.choiceLabels = savedLabels;
                } else {
                    $scope.ctxtCtrl.choiceLabels = {};
                }

            }
        }
        iniMultipleLabels();

        //endregion


        //region Ranking

        $scope.updatedRankingResponse = function (label, choice) {
            _.each(_.keys($scope.ctxtCtrl.choiceLabels), function (choiceLabel) {
                if (choiceLabel !== label.QuestionLabelID && $scope.ctxtCtrl.choiceLabels[choiceLabel] === choice.QuestionChoiceID) {
                    delete $scope.ctxtCtrl.choiceLabels[choiceLabel];
                }
            });

            $scope.templateSaveAnswer();
        };

        //endregion

        // region Numerical

        $scope.initNumericalQuestion = function () {

            var minNum = $scope.getAttributeValue('MinNumber');
            if (!_.isUndefined(minNum) && minNum !== '-1') {
                $scope.ctxtCtrl.minNumber = Number($scope.getAttributeValue('MinNumber'));
            }

            var maxNum = $scope.getAttributeValue('MaxNumber');
            if (!_.isUndefined(maxNum) && maxNum !== '-1') {
                $scope.ctxtCtrl.maxNumber = Number($scope.getAttributeValue('MaxNumber'));
            }

            if ($scope.ctxtCtrl.comment) {
                $scope.ctxtCtrl.comment = Number($scope.ctxtCtrl.comment);
            }
        };

        $scope.numericalFieldChanged = function () {
            var valid = true;

            if (isNaN($scope.ctxtCtrl.comment)
                || (!_.isUndefined($scope.ctxtCtrl.minNumber) && $scope.ctxtCtrl.comment < $scope.ctxtCtrl.minNumber)
                || (!_.isUndefined($scope.ctxtCtrl.maxNumber) && $scope.ctxtCtrl.comment > $scope.ctxtCtrl.maxNumber)) {

                valid = false;
            }

            $scope.ctxtCtrl.isAnswerValid = valid;
            !_.isUndefined($scope.campaignContext.form) && $scope.campaignContext.form.$setValidity('Numerical', valid);

            $scope.templateSaveAnswer();
        };

        // endregion
    }
})();